<div class="layout">
    <div class="layout-grid">
        <div class="layout-grid-header">
            <div class="layout-grid-header-body">
                <wbo-screen-layout-menu-bar></wbo-screen-layout-menu-bar>
            </div>
        </div>
        <wbo-screen-layout-sub-menu-header></wbo-screen-layout-sub-menu-header>
        <div class="layout-grid-menu">
            <div class="layout-grid-menu-body">
                <wbo-screen-layout-menu></wbo-screen-layout-menu>
            </div>
        </div>
        <div class="layout-grid-controls">
            <div *ngIf="!(editService.$entityRestricted | async)" [ngClass]="{'active': (screenLayoutEditorModel.painting$ | async)}"
                 class="layout-grid-controls-painter"
                 (click)="painting()"
                 [attr.title]="'wbo.screen-layout.edit.action.formatPainter' | translate"
                 [wbo-css-var]="{'--background': paintingColour, '--foreground': paintingForeColour}">
                <div class="layout-grid-controls-painter-colours background"></div>
                <div class="layout-grid-controls-painter-colours foreground"></div>
                <div class="layout-grid-controls-painter-icon">
                    <fui-icon [height]="23" [width]="30" icon="paint-brush"></fui-icon>
                </div>
            </div>

            <div class="layout-grid-controls-spinner">
                <div class="layout-grid-controls-spinner-label">
                    {{'wbo.screen-layout.edit.field.details.catColumns.label' | translate}}
                </div>
                <div class="layout-grid-controls-spinner-content">
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.numOfMenus <= 1 || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.decreaseNumOfMenus()">
                        <fui-icon icon="remove" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                    <div class="layout-grid-controls-spinner-content-value">
                        {{screenLayoutEditorModel.numOfMenus$ | async}}
                    </div>
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.numOfMenus >= ScreenLayoutEditorModel.MAX_MENUS_PER_PAGE || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.increaseNumOfMenus()">
                        <fui-icon icon="plus" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                </div>
            </div>

            <div class="layout-grid-controls-spinner">
                <div class="layout-grid-controls-spinner-label">
                    {{'wbo.screen-layout.edit.field.configCategories.touchItems.gridColumns.label' | translate}}
                </div>
                <div class="layout-grid-controls-spinner-content">
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.currentPage !== 0 || screenLayoutEditorModel.numOfColumns <= screenLayoutEditorModel.minColumns || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.removeColumn()">
                        <fui-icon icon="remove" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                    <div class="layout-grid-controls-spinner-content-value">
                        {{screenLayoutEditorModel.numOfColumns$ | async}}
                    </div>
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.currentPage !== 0 || screenLayoutEditorModel.numOfColumns >= ScreenLayoutEditorModel.MAX_COLUMNS || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.addColumn()">
                        <fui-icon icon="plus" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                </div>
            </div>

            <div class="layout-grid-controls-spinner">
                <div class="layout-grid-controls-spinner-label">
                    {{'wbo.screen-layout.edit.field.configCategories.touchItems.gridRows.label' | translate}}
                </div>
                <div class="layout-grid-controls-spinner-content">
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.currentPage !== 0 || screenLayoutEditorModel.numOfRows <= 1 || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.removeRow()">
                        <fui-icon icon="remove" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                    <div class="layout-grid-controls-spinner-content-value">
                        {{screenLayoutEditorModel.numOfRows$ | async}}
                    </div>
                    <fui-mark-button class="layout-grid-controls-spinner-content-button"
                                     [disabled]="screenLayoutEditorModel.currentPage !== 0 || screenLayoutEditorModel.numOfRows >= ScreenLayoutEditorModel.MAX_ROWS || (editService.$entityRestricted | async)"
                                     (click)="screenLayoutEditorModel.addRow()">
                        <fui-icon icon="plus" height="10" width="10"></fui-icon>
                    </fui-mark-button>
                </div>
            </div>

            <div *ngIf="!(editService.$entityRestricted | async)" class="layout-grid-controls-button">
                <wbo-screen-layout-touch-item-commands class="layout-grid-controls-button-commands"
                                                       [item]="screenLayoutEditorModel.selectedItem$ | async"
                                                       [menu]="screenLayoutEditorModel.selectedMenu$ | async"
                                                       [showAddMenu]="true"
                                                       [title]="'wbo.screen-layout.common.itemActions'">
                </wbo-screen-layout-touch-item-commands>
                <fui-pop-button [title]="'wbo.screen-layout.common.addPage'"
                                [disabled]="screenLayoutEditorModel.showNextPage || screenLayoutEditorModel.emptyPage"
                                (click)="screenLayoutEditorModel.nextMenuPage()"></fui-pop-button>
            </div>
        </div>

    </div>
    <div class="layout-properties">
        <div class="layout-properties-header">
            <wbo-screen-layout-menu-properties></wbo-screen-layout-menu-properties>
        </div>
        <div class="layout-properties-menu">
            <wbo-screen-layout-item-properties></wbo-screen-layout-item-properties>
        </div>
    </div>
</div>
<div class="display-warning">
    <fui-inline-warning
        [title]="'wbo.screen-layout.common.small-screen-edit.info.title'"
        [message]="'wbo.screen-layout.common.small-screen-edit.info.message'">
    </fui-inline-warning>
</div>

